import { makeStyles } from '@material-ui/styles';

export const useBreadCrumsStyles = makeStyles(() => ({
  breadCrumbs: {
    marginTop: 20,
    marginBottom: 30,
  },
  currentBreadcrumb: {
    color: '#6A148E',
    fontSize: 12,
    fontWeight: 600,
  },
  otherBreadcrumb: {
    cursor: 'pointer',
    color: '#464646',
    fontSize: 12,
  },
}));
